.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background-color: var(--tuna-surface-default);
}

.header {
  display: flex;
  justify-content: flex-end;
}

.score {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-caption-fontSize);
}

.hearItButton {
  align-self: center;
  min-width: 160px;
}

.answerGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--tuna-spacing-2);
  border: none;
  padding: 0;
  margin: 0;
}

.legend {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.answerButton {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: var(--tuna-spacing-3);
  min-height: 72px;
}

.answerShort {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
  text-transform: uppercase;
}

.answerLong {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
}
